import { render, staticRenderFns } from "./InstructorForm.vue?vue&type=template&id=24bf4132"
import script from "./InstructorForm.vue?vue&type=script&lang=ts"
export * from "./InstructorForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports